// @ts-strict-ignore
import React from 'react';
import {
  ButtonSize,
  ButtonVariant,
  Checkbox,
} from '@usealloy/component-library';

import { snakeToCaps } from '~/helpers/formatting';
import {
  CheckboxToggleWrapper,
  MetadataItemWrapper,
  ModalConcealerText,
  ModalValueText,
  ToggleParentKeys,
} from './styles';
import { formatCheckboxValues } from './helpers';

interface MetadataCheckboxProps {
  checked: boolean;
  handleHideParentKeys?: () => void;
  handleToggle: (boolean) => void;
  hideParentKeys?: boolean;
  label: string;
  showToggle?: boolean;
  value: any;
}

const MetadataCheckbox = ({
  checked,
  handleHideParentKeys,
  handleToggle,
  hideParentKeys,
  label,
  showToggle,
  value,
}: MetadataCheckboxProps) => {
  const valueText = formatCheckboxValues(value);
  const useConcealer = valueText.length > 140;
  return (
    <MetadataItemWrapper
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <CheckboxToggleWrapper
        direction="row"
        justifyContent="flex-start"
        gap={2}
        className={showToggle ? 'checkbox-wrapper-show-toggle' : 'checkbox-wrapper-no-toggle'}
        style={{ wordBreak: 'keep-all' }}
      >
        <Checkbox
          data-testid={`checkbox-${label}`}
          checked={checked}
          label={snakeToCaps(label)}
          onChange={event => { handleToggle(event.target.checked); }}
          style={{
            maxWidth: '100%',
          }}
        />
        {checked && showToggle && (
          <ToggleParentKeys
            size={ButtonSize.small}
            variant={ButtonVariant.tertiary}
            onClick={handleHideParentKeys}
          >
            {`${hideParentKeys ? 'Show' : 'Hide'} Parent Keys`}
          </ToggleParentKeys>
        )}
      </CheckboxToggleWrapper>
      {
      useConcealer
        ? (
          <ModalConcealerText text={valueText} />
        ) : (
          <ModalValueText>{valueText}</ModalValueText>
        )
      }
    </MetadataItemWrapper>
  );
};

export default MetadataCheckbox;
